module.exports = __webpack_public_path__ + "img/zhujinge.c85b1c87.jpg";